import type { BadgeType } from '@skytech/ui/Badge'

import type { CoreGreenpoolOrder, MainGreenpoolOrder, OrderCoreData, OrderStatus } from '../types'

export function getBadgeTypeFromStatus(status: OrderStatus): BadgeType {
  if (status === 'REJECTED' || status === 'CANCELED') return 'negative'
  if (status === 'ACCEPTED' || status === 'ORDER_CONFIRMED' || status === 'DELIVERED')
    return 'positive'

  return 'neutral'
}

export function mergeAndSortOrders(orders: OrderCoreData[], greenpoolOrders: MainGreenpoolOrder[]) {
  return [...orders, ...greenpoolOrders].sort(
    (a, b) => new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime()
  )
}

export function isCoreOrder(order: CoreGreenpoolOrder): order is OrderCoreData {
  return 'status' in order
}
